import { createRouter, createWebHistory, RouteRecordRaw, RouterOptions } from "vue-router";
import auth from "@/router/auth";

export const routes: RouteRecordRaw[] = [
  {
    path: "/dossier/:id",
    name: "Public Dossier",
    component: () => import("@/views/public/dossiers/PublicDossierView.vue"),
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/request-password-reset",
    name: "Request Password Reset",
    component: () => import("@/views/RequestPasswordReset.vue"),
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/change-expired-password",
    name: "Change Expired Password",
    component: () => import("@/views/ChangeExpiredPassword.vue"),
    meta: { requiresAuth: true, allowExpiredPassword: true },
  },
  {
    path: "/auth/microsoft/callback",
    name: "Microsoft Callback",
    component: () => import("@/views/MicrosoftCallback.vue"),
  },
  {
    path: "/oauth/authorize",
    name: "OAuth Authorize",
    component: () => import("@/views/OAuthAuthorize.vue"),
  },
  {
    path: "/onboarding/:token",
    name: "Public Onboarding",
    component: () => import("@/views/public/onboarding/PublicOnboardingPortal.vue"),
    props: true,
  },
  auth,
  {
    path: "/:pathMatch(.*)*",
    name: "Public 404",
    component: () => import("@/views/public/404.vue"),
    props: true,
  },
];

const router = createRouter(<RouterOptions>{
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
